import axios from 'axios';
import { TReportLeaderBoardRow } from '@src/types/reports';

export type TLeaderboardParams = {
  product_id?: number | null;
  from_date?: string | null;
  to_date?: string | null;
  page: number;
  page_size: number;
};

export type TLeaderboardRes = {
  data: TReportLeaderBoardRow[];
  total: number;
  page: number;
  page_size: number;
  total_pages: number;
};

export const getLeaderboard = async (
  payload: TLeaderboardParams
): Promise<TLeaderboardRes> => {
  const { data } = await axios.post('/leader-board/', payload);

  return data;
};
